import { FieldErrors } from 'react-hook-form'

/**
 * @function findErrorMessageInFieldErrors
 * @param {FieldErrors} errors An object with field errors.
 * @param {string} key Name of the TextInput
 * @returns {String}
 */
function findErrorMessageInFieldErrors(
  errors: FieldErrors,
  key: string,
) {
  return errors?.hasOwnProperty(key) ? errors[key]?.message : null
}

/**
 * @function shouldDisplayError
 * @param {FieldErrors} errors An object with field errors.
 * @param {string} name Name of the TextInput
 * @param {boolean} error (optional)
 * @returns {boolean}
 */
export function shouldDisplayError(
  errors: FieldErrors = {},
  name: string,
  error?: boolean,
): boolean {
  return error === true || Boolean(findErrorMessageInFieldErrors(errors, name))
}

/**
 * @function deriveErrorMessage
 * @param {FieldErrors} errors An object with field errors
 * @param {string} name Name of the TextInput
 * @param {string} helperText (optional) The helper text content
 * @returns {String}
 */
export function deriveErrorMessage(
  errors: FieldErrors = {},
  name: string,
  helperText?: string,
): string {
  return (findErrorMessageInFieldErrors(errors, name) || helperText) as string
}
